import React from "react";
// Missing Reads Dashboard Page

// Mui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";

// Custom
import Layout from "../../layout";
import MissingReadsDashboardBarChart from "../charts/MissingReadsDashboardBarChart";
import CustomSearch from "../search/Search";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomOutlinedSelect from "../../forms/select/OutlinedCustomSelect";
import CustomDataTable from "../table/CustomTable";

const MissingReadsDashboard: React.FC = () => {
  const readsData = [
    { type: "Critical", number: 14, bg: "#fad2d2", color: "#FA6B6B" },
    { type: "Major", number: 14, bg: "#fae5be", color: "#F8BB45" },
    { type: "Minor", number: 22, bg: "#d9f7ba", color: "#94DB4B" },
  ];

  const data = [];
  return (
    <Layout>
      <Grid container spacing={2.25}>
        {readsData?.map((read) => {
          return (
            <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <Box
                sx={{
                  background: read.bg,
                  padding: "15px",
                  borderRadius: "5px",
                }}
              >
                <Typography variant="h5" fontWeight={500} color={read.color}>
                  {read?.type}
                </Typography>
                <Typography
                  variant="body1"
                  color={read.color}
                  ml={"2px"}
                  mt={"4px"}
                >
                  {read?.number}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <Card sx={{ mt: "20px", maxHeight: "400px" }}>
        <CardContent>
          <MissingReadsDashboardBarChart />
        </CardContent>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <CardHeader
          title={
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <CustomSearch
                placeholder={"Search by Meter ID or Location"}
                sx={{ width: "600px", height: "44px" }}
              />

              <Stack direction={"row"} alignItems={"center"} gap={"10px"}>
                <CustomOutlinedSelect
                  placeholder={"Select status"}
                  options={[]}
                  width="fit-content"
                />

                <CustomOutlinedSelect
                  placeholder={"Select type"}
                  options={[]}
                  width="fit-content"
                />

                <ContainedButton
                  label={"Download CSV"}
                  sx={{
                    width: "fit-content",
                    fontWeight: 600,
                    height: "43px",
                    color: "#ffffff",
                  }}
                  disabled={data?.length === 0}
                />
              </Stack>
            </Stack>
          }
        />
        <Divider />

        <CardContent sx={{ overflow: "auto", maxHeight: "600px" }}>
          <CustomDataTable
            columns={[
              "Meter ID",
              "Location",
              "Type",
              "Last Read Time",
              "Missing Intervals",
              "Success Rate",
              "Status",
            ]}
            pagination={true}
            rowsContent={[]}
            Actions={true}
          />
        </CardContent>
      </Card>
    </Layout>
  );
};

export default MissingReadsDashboard;
